import { render, staticRenderFns } from "./SucCalendarComponent.vue?vue&type=template&id=2660fc8c&"
import script from "./SucCalendarComponent.vue?vue&type=script&lang=js&"
export * from "./SucCalendarComponent.vue?vue&type=script&lang=js&"
import style0 from "./SucCalendarComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports